import { Person } from '@mui/icons-material';
import clsx from 'clsx';
import style from './style.module.scss';
import { numberWithSpaces } from '../utils';

export const Profile = ({ user, classNames, myAccountLink, sponsorPageLink, rulesGameLink }) => {
    return (
        <div className={clsx(style.block, classNames)}>
            <div className={style.content}>
                <div className={style.userInfo}>
                    <div className={style.userName}>
                        Hello <span>{user.first_name}</span>
                    </div>
                    <div className={style.row}>
                        <div className={style.score}>
                            ⭐️
                            <span>{numberWithSpaces(user.points)}</span> pts.
                        </div>
                        <div className={style.rank}>
                            <img src={user.rank_image} alt={user.rank} />
                            {user.rank}
                        </div>
                    </div>
                </div>

                <div className={style.avatar}>
                    {user.image ? <img src={user.image} alt={`Avatar de ${user.first_name}`} /> : <Person />}
                </div>
                <ul className={style.links}>
                    {myAccountLink && (
                        <li>
                            <a href={myAccountLink}>Mon compte</a>
                        </li>
                    )}
                    {sponsorPageLink && (
                        <li>
                            <a href={sponsorPageLink}>Parrainage</a>
                        </li>
                    )}
                    {rulesGameLink && (
                        <li>
                            <a href={rulesGameLink}>Règles du jeu</a>
                        </li>
                    )}
                    <li>
                        <a href="/wp-json/myhand-user/v1/logout">Se déconnecter</a>
                    </li>
                </ul>
            </div>
        </div>
    );
};
